import { Link } from "react-router-dom";
import { ChevronRight, Plus, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

function ServiceCard({ service, index }) {
  return (
    <Reveal delay={(index % 2) * 0.1} className={SPANS[index % 4]}>
      <article
        className="group relative h-full border border-white/10 bg-coal overflow-hidden hover:border-electric/60 transition-colors"
        data-testid={`service-card-${service.id}`}
      >
        {service.image && (
          <div className="relative h-52 sm:h-60 overflow-hidden">
            <img
              src={service.image}
              alt={service.title}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-coal via-transparent to-transparent" />
          </div>
        )}
        <div className="p-7 sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <span className="font-display text-sm text-gray-600">0{index + 1}</span>
            {service.price && (
              <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-electric-bright border border-electric/40 px-3 py-1">
                {service.price}
              </span>
            )}
          </div>
          <h3 className="mt-3 font-display text-2xl sm:text-3xl font-semibold uppercase tracking-tight text-white">
            {service.title}
          </h3>
          {service.tagline && (
            <p className="mt-1 text-sm font-semibold text-electric-bright">{service.tagline}</p>
          )}
          <p className="mt-4 text-sm text-gray-400 leading-relaxed">{service.description}</p>
          {service.points?.length > 0 && (
            <ul className="mt-5 space-y-2">
              {service.points.map((p, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-gray-300">
                  <ChevronRight size={14} className="text-electric-bright shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
          )}
          <Link
            to={`/services/${service.id}`}
            data-testid={`service-learn-more-${service.id}`}
            className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white hover:text-electric-bright transition-colors"
          >
            Learn More <ArrowRight size={14} />
          </Link>
        </div>
      </article>
    </Reveal>
  );
}

export default function Services({ content }) {
  return (
    <section id="services" className="scroll-mt-20 py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Our Services"
          title="Engineered performance, tailored to your vehicle"
        />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {content.services.map((s, i) => (
            <ServiceCard key={s.id || i} service={s} index={i} />
          ))}
          <Reveal delay={0.1} className={SPANS[content.services.length % 4]}>
            <div className="h-full min-h-[220px] border border-dashed border-white/15 flex flex-col items-center justify-center gap-4 p-10 text-center hover:border-electric/50 transition-colors" data-testid="services-more-card">
              <span className="h-11 w-11 border border-white/20 flex items-center justify-center text-electric-bright">
                <Plus size={20} />
              </span>
              <p className="font-display text-xl uppercase tracking-tight text-white">More services launching soon</p>
              <p className="text-sm text-gray-500 max-w-xs">Talk to us about your build — if it involves performance, we want to hear about it.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
